module.exports = __webpack_public_path__ + "img/PART-alt.4e567a72.svg";